"use client";

import { useEffect, useState } from "react";
import styles from "./mobile-notice.module.scss";
import MonitorIcon from "@mui/icons-material/Monitor";

export default function MobileDesktopNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 1024) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.iconWrap}>
          <MonitorIcon className={styles.icon} />
        </div>
        <h2 className={styles.title}>Best viewed on desktop</h2>
        <p className={styles.body}>
          The PeatSense services page is optimised for desktop screens
          (1024×768 or larger). Some features may be limited on smaller devices.
        </p>
        <button className={styles.btn} onClick={() => setVisible(false)}>
          Got it
        </button>
      </div>
    </div>
  );
}
